import { useUser } from "@saleor/auth";
import { DeliveryReportUrlQueryParams } from "@saleor/deliveryReport/urls";
import DeliveryReportAdmin from "@saleor/deliveryReport/views/DeliveryReportAdmin";
import DeliveryReportCustomer from "@saleor/deliveryReport/views/DeliveryReportCustomer";
import { PermissionEnum } from "@saleor/graphql";
import React, { useMemo } from "react";

export interface DeliveryReportProps {
  params: DeliveryReportUrlQueryParams;
}

const DeliveryReportView: React.FC<DeliveryReportProps> = ({ params }) => {
  const { user } = useUser();

  const isCustomer = useMemo(
    () =>
      !!user.userPermissions.find(
        e => e.code === PermissionEnum.ALL_REPORT_CUSTOMER
      ),
    [user.userPermissions]
  );

  return (
    <>
      {isCustomer ? (
        <DeliveryReportCustomer params={params} />
      ) : (
        <DeliveryReportAdmin params={params} />
      )}
    </>
  );
};

export default DeliveryReportView;
